import { render, staticRenderFns } from "./baseDialog.vue?vue&type=template&id=e26ebe2a&scoped=true"
import script from "./baseDialog.vue?vue&type=script&lang=js"
export * from "./baseDialog.vue?vue&type=script&lang=js"
import style0 from "./baseDialog.vue?vue&type=style&index=0&id=e26ebe2a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e26ebe2a",
  null
  
)

export default component.exports